"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1273],{

/***/ 41720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61810);
/* harmony import */ var _utils_formatPhone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98819);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);





var ClientBox = function ClientBox(_ref) {
  var name = _ref.name,
      email = _ref.email,
      company = _ref.company,
      phone = _ref.phone,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      badge = _ref.badge;
  var displayName = name || company || (phone ? (0,_utils_formatPhone__WEBPACK_IMPORTED_MODULE_1__/* .formatKoreanPhoneNumber */ .s$)(phone) : null) || email || '(이름 없음)';
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
    backgroundColor: disabled ? 'zinc_200' : 'white',
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Flex */ .kC, {
      alignItems: "center",
      justifyContent: "space-between",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Stack */ .Kq, {
          direction: "row",
          gap: 6,
          alignItems: "center",
          marginBottom: 4,
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
            as: "p",
            variant: "md-semibold",
            color: disabled ? 'zinc_400' : 'black',
            children: displayName
          }), badge]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
          as: "p",
          variant: "sm-regular",
          color: disabled ? 'zinc_400' : 'black',
          children: email
        })]
      }), disabled || (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("button", {
        onClick: onClick,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .JO, {
          icon: "ph:plus",
          size: 17,
          color: "black"
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ClientBox);

/***/ }),

/***/ 5354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HN": function() { return /* reexport */ AddClientList_AddedClientList; },
  "uT": function() { return /* reexport */ AddClientList_Body; },
  "if": function() { return /* reexport */ ExistingClient_ClientBox/* default */.Z; },
  "Y2": function() { return /* reexport */ AddClientList_ClientTabs; },
  "Qk": function() { return /* reexport */ ClientTabs_ExistingClient; },
  "$_": function() { return /* reexport */ AddClientList_Footer; },
  "_r": function() { return /* reexport */ ClientTabs_NewClient; },
  "fC": function() { return /* reexport */ AddClientList_Root; },
  "R8": function() { return /* reexport */ AddedClientList_ClientBox; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/Root/index.tsx




var Root = function Root(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Stack */.Kq, {
    direction: "column",
    gap: 16,
    marginBottom: 56,
    children: children
  });
};

/* harmony default export */ var AddClientList_Root = (Root);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/AddedClientList/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g6jpit2"
} : 0)( true ? {
  name: "14lc68n",
  styles: "width:100%;height:50vh;max-height:650px"
} : 0);
var StackAddedClientsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1g6jpit1"
} : 0)( true ? {
  name: "165khm",
  styles: "max-height:calc(100% - 41px);overflow-y:auto;&.empty{height:calc(100% - 41px);}"
} : 0);
var EmptyText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "e1g6jpit0"
} : 0)( true ? {
  name: "uipqd4",
  styles: "display:flex;width:100%;align-items:center;justify-content:center"
} : 0);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/AddedClientList/index.tsx






var AddedClientList = function AddedClientList(_ref) {
  var name = _ref.name,
      children = _ref.children;
  var isEmpty = react.Children.count(children) === 0;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
      variant: "md-semibold",
      marginBottom: 24,
      children: [name, " \uBC1B\uC544\uBCFC \uACE0\uAC1D"]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StackAddedClientsWrapper, {
      gap: 8,
      wrap: "wrap",
      className: isEmpty ? 'empty' : '',
      children: isEmpty ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmptyText, {
        as: "p",
        variant: "md-medium",
        color: "zinc_400",
        textAlign: "center",
        children: ["\uC774\uACF3\uC5D0 \uCD94\uAC00\uB41C \uACE0\uAC1D \uD55C \uBD84\uB9C8\uB2E4", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uBC18\uC751 \uD30C\uC545\uC6A9 \uB9C1\uD06C\uAC00 \uC0DD\uC131\uB429\uB2C8\uB2E4."]
      }) : children
    })]
  });
};

/* harmony default export */ var AddClientList_AddedClientList = (AddedClientList);
// EXTERNAL MODULE: ./utils/formatPhone.ts
var formatPhone = __webpack_require__(98819);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/AddedClientList/ClientBox/index.styles.ts


function index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var index_styles_ClientBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14vpik51"
} : 0)("width:166px;min-height:44px;flex-basis:166px;padding:8px 12px;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.skyblue_100;
}, ";border-radius:4px;white-space:pre-wrap;word-break:break-all;" + ( true ? "" : 0));
var Button = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e14vpik50"
} : 0)( true ? {
  name: "16qjhms",
  styles: "height:17px"
} : 0);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/AddedClientList/ClientBox/index.tsx






var ClientBox = function ClientBox(_ref) {
  var name = _ref.name,
      email = _ref.email,
      company = _ref.company,
      phone = _ref.phone,
      onClick = _ref.onClick;
  var displayName = name || company || (phone ? (0,formatPhone/* formatKoreanPhoneNumber */.s$)(phone) : null) || email || '(이름 없음)';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_ClientBox, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
      justifyContent: "space-between",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          as: "p",
          variant: "sm-medium",
          color: "skyblue_500",
          children: displayName
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          as: "p",
          variant: "sm-regular",
          color: "skyblue_500",
          children: email !== null && email !== void 0 ? email : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {})
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, {
        onClick: onClick,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:x-light",
          size: 14,
          color: "skyblue_500"
        })
      })]
    })
  });
};

/* harmony default export */ var AddedClientList_ClientBox = (ClientBox);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/Body/index.styles.ts


function Body_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var FlexWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1di5duy0"
} : 0)( true ? {
  name: "1im0r96",
  styles: "overflow-y:scroll"
} : 0);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/Body/index.tsx




var Body = function Body(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlexWrapper, {
    marginBottom: 16,
    children: children
  });
};

/* harmony default export */ var AddClientList_Body = (Body);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-tabs/dist/index.mjs
var dist = __webpack_require__(64266);
;// CONCATENATED MODULE: ./styles/Tabs.styles.ts


function Tabs_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var TabsRoot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Root */.fC,  true ? {
  target: "espjonw4"
} : 0)( true ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : 0);
var TabsList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* List */.aV,  true ? {
  target: "espjonw3"
} : 0)( true ? {
  name: "4t0por",
  styles: "display:flex;width:100%;margin-bottom:16px;gap:8px"
} : 0);
var TabsIdContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "espjonw2"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
var TabsTrigger = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Trigger */.xz,  true ? {
  target: "espjonw1"
} : 0)("width:100%;padding:16px;border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, ";border-radius:4px;color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.zinc_400;
}, ";font-size:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize.md;
}, ";font-weight:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeight.semibold;
}, ";line-height:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.lineHeight.md;
}, ";transition:all 0.15s ease-in-out;&[data-state='active'],&:hover{border:1px solid ", function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.skyblue_300;
}, ";background-color:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.white;
}, ";color:", function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.skyblue_300;
}, ";}" + ( true ? "" : 0));
var TabsContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Content */.VY,  true ? {
  target: "espjonw0"
} : 0)("height:", function (_ref10) {
  var height = _ref10.height;
  return height !== null && height !== void 0 ? height : 'auto';
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/ClientTabs/index.styles.ts


var index_styles_TabsRoot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Root */.fC,  true ? {
  target: "e182v3fh0"
} : 0)("height:50vh;max-height:650px;flex:0 0 329px;padding-right:16px;border-right:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";margin-right:16px;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/ClientTabs/index.tsx






var tabValues = {
  newClient: {
    name: '새로운 고객'
  },
  existingClient: {
    name: '저장된 고객'
  }
};

var ClientTabs = function ClientTabs(_ref) {
  var newClient = _ref.newClient,
      existingClient = _ref.existingClient;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_styles_TabsRoot, {
    defaultValue: tabValues.newClient.name,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "md-semibold",
      marginBottom: 8,
      children: "\uB204\uAD6C\uC5D0\uAC8C \uBCF4\uB0B4\uC2E4 \uAC74\uAC00\uC694?"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsList, {
      children: Object.values(tabValues).map(function (_ref2) {
        var name = _ref2.name;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsIdContainer, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsTrigger, {
            value: name,
            children: name
          }, name)
        }, name);
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsContent, {
      value: tabValues.newClient.name,
      children: newClient
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsContent, {
      value: tabValues.existingClient.name,
      height: "calc(100% - 123px)",
      children: existingClient
    })]
  });
};

/* harmony default export */ var AddClientList_ClientTabs = (ClientTabs);
// EXTERNAL MODULE: ./components/User/_components/common/SortTypeDropdown/index.tsx + 1 modules
var SortTypeDropdown = __webpack_require__(69135);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/ClientTabs/ExistingClient/index.styles.ts


function ExistingClient_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var StackClientListWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e9264u80"
} : 0)( true ? {
  name: "1hq41aj",
  styles: "height:100%;margin-top:16px;overflow-y:scroll"
} : 0);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/ClientTabs/ExistingClient/index.tsx
function ExistingClient_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var items = [{
  label: '고객 대표명 순',
  value: 'name'
}];
var buttonCss =  true ? {
  name: "1i44aga",
  styles: "min-width:61px;height:17px;padding:0 0 0 8px;border:0"
} : 0;

var ExistingClient = function ExistingClient(_ref) {
  var children = _ref.children,
      addAllClients = _ref.addAllClients;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
      alignItems: "center",
      justifyContent: "space-between",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
        display: "inline-flex",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "md-semibold",
          marginRight: 8,
          children: "\uACE0\uAC1D \uBAA9\uB85D"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SortTypeDropdown/* default */.Z, {
          items: items,
          onValueChanges: function onValueChanges() {},
          buttonCss: buttonCss,
          align: "start",
          sideOffset: 12
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        variant: "skyblue_400",
        textVariant: "sm-semibold",
        borderLess: true,
        rightIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:plus",
          size: 17
        }),
        onClick: function onClick() {
          return addAllClients();
        },
        children: "\uBAA8\uB450 \uCD94\uAC00\uD558\uAE30"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StackClientListWrapper, {
      direction: "column",
      gap: 8,
      children: children
    })]
  });
};

/* harmony default export */ var ClientTabs_ExistingClient = (ExistingClient);
// EXTERNAL MODULE: ./components/User/_components/common/AddClientList/ClientTabs/ExistingClient/ClientBox/index.tsx
var ExistingClient_ClientBox = __webpack_require__(41720);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(6364);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../packages/styles/index.ts + 3 modules
var styles = __webpack_require__(97223);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 1 modules
var useQuery = __webpack_require__(7040);
// EXTERNAL MODULE: ./utils/api.ts + 1 modules
var api = __webpack_require__(74457);
;// CONCATENATED MODULE: ./hooks/queries/client/useClientCheck.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getClientCheck = function getClientCheck(_ref) {
  var email = _ref.email;
  return api/* api.get */.h.get('/client/check', {
    params: {
      email: email
    }
  });
};

var useClientCheck = function useClientCheck(request, options) {
  return (0,useQuery/* useQuery */.a)(['getClientCheck', request], function () {
    return getClientCheck(request);
  }, _objectSpread({}, options));
};

/* harmony default export */ var client_useClientCheck = (useClientCheck);
// EXTERNAL MODULE: ./constants/formValidations.ts
var formValidations = __webpack_require__(65118);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/ClientTabs/NewClient/index.tsx




function NewClient_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NewClient_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NewClient_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NewClient_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var RequiredNotice = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ekh13uu1"
} : 0)("padding:8px 12px;background:", styles/* theme.colors.zinc_50 */.rS.colors.zinc_50, ";border-radius:4px;border:1px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";" + ( true ? "" : 0));

var Textarea = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("textarea",  true ? {
  target: "ekh13uu0"
} : 0)("width:100%;padding:8px 16px;border-radius:4px;resize:vertical;min-height:80px;font-size:", styles/* theme.fontSize.md */.rS.fontSize.md, ";line-height:", styles/* theme.lineHeight.md */.rS.lineHeight.md, ";font-weight:", styles/* theme.fontWeight.regular */.rS.fontWeight.regular, ";&::placeholder{color:", styles/* theme.colors.zinc_400 */.rS.colors.zinc_400, ";font-weight:300;}", function (_ref) {
  var isError = _ref.isError;
  return isError ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("border:1px solid ", styles/* theme.colors.cerise_500 */.rS.colors.cerise_500, ";background:", styles/* theme.colors.cerise_50 */.rS.colors.cerise_50, ";color:", styles/* theme.colors.zinc_500 */.rS.colors.zinc_500, ";" + ( true ? "" : 0),  true ? "" : 0) : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("border:1px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";background:", styles/* theme.colors.zinc_50 */.rS.colors.zinc_50, ";color:", styles/* theme.colors.zinc_500 */.rS.colors.zinc_500, ";" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var NewClient = function NewClient(_ref2) {
  var addClient = _ref2.addClient,
      clients = _ref2.clients,
      clientCount = _ref2.clientCount,
      planLimitLabel = _ref2.planLimitLabel,
      isAtLimit = _ref2.isAtLimit,
      onLimitExceeded = _ref2.onLimitExceeded;

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      setError = _useForm.setError,
      watch = _useForm.watch,
      getValues = _useForm.getValues,
      setValue = _useForm.setValue,
      reset = _useForm.reset,
      errors = _useForm.formState.errors;

  var email = watch('email');
  var name = watch('name');
  var phone = watch('phone');
  var company = watch('company');

  var _useClientCheck = client_useClientCheck({
    email: email
  }, {
    enabled: false,
    select: function select(data) {
      return data.data.data;
    },
    retry: false,
    onSuccess: function onSuccess() {
      var values = getValues();
      addClient({
        id: (0,v4/* default */.Z)(),
        name: values.name || null,
        email: values.email || null,
        company: values.company || null,
        phone: values.phone ? (0,formatPhone/* stripPhone */.Wr)(values.phone) : null,
        position: values.position || null,
        department: values.department || null,
        memo: values.memo || null,
        isSelected: false
      });
      reset();
    },
    onError: function onError(error) {
      var _error$response;

      if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 409) {
        setError('email', {
          message: error === null || error === void 0 ? void 0 : error.response.data.message
        });
        return;
      }

      setError('email', {
        message: '이메일을 확인해주세요.'
      });
    }
  }),
      refetch = _useClientCheck.refetch;

  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref3) {
      var name, email, company, phone, position, department, memo, isDuplicatedEmail;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              name = _ref3.name, email = _ref3.email, company = _ref3.company, phone = _ref3.phone, position = _ref3.position, department = _ref3.department, memo = _ref3.memo;

              if (!isAtLimit) {
                _context.next = 4;
                break;
              }

              onLimitExceeded === null || onLimitExceeded === void 0 ? void 0 : onLimitExceeded();
              return _context.abrupt("return");

            case 4:
              if (!(!name && !phone && !company && !email)) {
                _context.next = 7;
                break;
              }

              setError('name', {
                type: 'required',
                message: formValidations/* CLIENT_IDENTITY_REQUIRED_MESSAGE */.D
              });
              return _context.abrupt("return");

            case 7:
              isDuplicatedEmail = email && (clients === null || clients === void 0 ? void 0 : clients.some(function (client) {
                return client.email === email;
              }));

              if (!isDuplicatedEmail) {
                _context.next = 11;
                break;
              }

              setError('email', {
                message: '이미 존재하는 이메일입니다.'
              });
              return _context.abrupt("return");

            case 11:
              if (email) {
                _context.next = 15;
                break;
              }

              addClient({
                id: (0,v4/* default */.Z)(),
                name: name || null,
                email: null,
                company: company || null,
                phone: phone ? (0,formatPhone/* stripPhone */.Wr)(phone) : null,
                position: position || null,
                department: department || null,
                memo: memo || null,
                isSelected: false
              });
              reset();
              return _context.abrupt("return");

            case 15:
              refetch();

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    as: "form",
    onSubmit: handleSubmit(onSubmit),
    direction: "column",
    gap: 16,
    children: [clientCount !== undefined && planLimitLabel && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
      justifyContent: "flex-end",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        display: "inline-flex",
        gap: 8,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
          variant: "md-medium",
          color: "zinc_500",
          children: [clientCount.toLocaleString(), " / ", planLimitLabel]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* IconTooltip */.MC, {
          iconProps: {
            icon: 'ph:question-fill',
            size: 17,
            color: 'zinc_400'
          },
          children: ["- Free \uD50C\uB79C\uC740 \uACE0\uAC1D\uC744 10\uBA85\uAE4C\uC9C0 \uB4F1\uB85D\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "- Basic \uD50C\uB79C\uC740 \uACE0\uAC1D\uC744 100\uBA85\uAE4C\uC9C0 \uB4F1\uB85D\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "- Pro \uD50C\uB79C\uC740 \uACE0\uAC1D\uC744 1,000\uBA85\uAE4C\uC9C0 \uB4F1\uB85D\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "- Pro+ \uD50C\uB79C\uC740 \uACE0\uAC1D\uC744 10,000\uBA85\uAE4C\uC9C0 \uB4F1\uB85D\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."]
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 16,
      direction: "column",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RequiredNotice, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "sm-regular",
          color: "zinc_400",
          children: "* ".concat(formValidations/* CLIENT_IDENTITY_REQUIRED_MESSAGE */.D)
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
            alignItems: "center",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              as: "p",
              variant: "md-semibold",
              marginBottom: 8,
              marginRight: 2,
              children: "\uACE0\uAC1D \uC774\uB984"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              as: "p",
              variant: "sm-regular",
              color: "cerise_500",
              marginBottom: 8,
              children: "*"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, NewClient_objectSpread({
            type: "text",
            width: "100%",
            placeholder: "\uC790\uB8CC\uB97C \uBC1B\uC544\uBCFC \uACE0\uAC1D\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
            isError: Boolean(errors.name)
          }, register('name')))]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
          errors: errors,
          name: "name"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
            alignItems: "center",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              as: "p",
              variant: "md-semibold",
              marginBottom: 8,
              marginRight: 2,
              children: "\uD68C\uC0AC\uBA85"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              as: "p",
              variant: "sm-regular",
              color: "cerise_500",
              marginBottom: 8,
              children: "*"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, NewClient_objectSpread({
            type: "text",
            width: "100%",
            placeholder: "\uD68C\uC0AC\uBA85\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
            isError: Boolean(errors.company)
          }, register('company')))]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
          errors: errors,
          name: "company"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
            alignItems: "center",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              as: "p",
              variant: "md-semibold",
              marginBottom: 8,
              marginRight: 2,
              children: "\uC5F0\uB77D\uCC98"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              as: "p",
              variant: "sm-regular",
              color: "cerise_500",
              marginBottom: 8,
              children: "*"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, NewClient_objectSpread({
            type: "text",
            width: "100%",
            placeholder: "\uC608) 010-1234-5678",
            isError: Boolean(errors.phone)
          }, register('phone', {
            onChange: function onChange(e) {
              setValue('phone', (0,formatPhone/* formatPhone */.CN)(e.target.value), {
                shouldValidate: true
              });
            }
          })))]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
          errors: errors,
          name: "phone"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "md-semibold",
            marginBottom: 8,
            marginRight: 4,
            children: "\uACE0\uAC1D \uC774\uBA54\uC77C"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, NewClient_objectSpread({
            type: "text",
            width: "100%",
            placeholder: "\uC608) example@salesclue.io",
            isError: Boolean(errors.email)
          }, register('email', {
            pattern: {
              value: formValidations/* FORM_VALIDATIONS.email.pattern.value */.R.email.pattern.value,
              message: formValidations/* FORM_VALIDATIONS.email.pattern.message */.R.email.pattern.message
            }
          })))]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
          errors: errors,
          name: "email"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "md-semibold",
            marginBottom: 8,
            children: "\uC9C1\uCC45"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, NewClient_objectSpread({
            type: "text",
            width: "100%",
            placeholder: "\uC9C1\uCC45\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
            isError: Boolean(errors.position)
          }, register('position')))]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
          errors: errors,
          name: "position"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "md-semibold",
            marginBottom: 8,
            children: "\uBD80\uC11C"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, NewClient_objectSpread({
            type: "text",
            width: "100%",
            placeholder: "\uBD80\uC11C\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
            isError: Boolean(errors.department)
          }, register('department')))]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
          errors: errors,
          name: "department"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "md-semibold",
            marginBottom: 8,
            children: "\uBA54\uBAA8"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Textarea, NewClient_objectSpread({
            placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694. (\uCD5C\uB300 500\uC790)",
            isError: Boolean(errors.memo)
          }, register('memo', {
            maxLength: {
              value: formValidations/* FORM_VALIDATIONS.memo.maxLength.value */.R.memo.maxLength.value,
              message: formValidations/* FORM_VALIDATIONS.memo.maxLength.message */.R.memo.maxLength.message
            }
          })))]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
          errors: errors,
          name: "memo"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
      justifyContent: "flex-end",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        type: "submit",
        variant: "skyblue_400",
        radius: 4,
        width: "152px",
        textVariant: "md-medium",
        disabled: !name && !phone && !company && !email,
        children: "\uC0C8\uB85C\uC6B4 \uACE0\uAC1D \uC0DD\uC131\uD558\uAE30"
      })
    })]
  });
};

/* harmony default export */ var ClientTabs_NewClient = (NewClient);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/Footer/index.styles.ts


function Footer_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var index_styles_FlexWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1nkymbt0"
} : 0)( true ? {
  name: "muq8pz",
  styles: "position:fixed;bottom:0;left:50%;transform:translateX(-50%)"
} : 0);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/Footer/index.tsx




var Footer = function Footer(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_FlexWrapper, {
    justifyContent: "center",
    backgroundColor: "white",
    padding: {
      y: 16
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        variant: "skyblue_500_fill",
        paddingY: 16,
        radius: 4,
        width: "349px",
        textVariant: "lg-medium",
        disabled: disabled,
        onClick: onClick,
        children: children
      })
    })
  });
};

/* harmony default export */ var AddClientList_Footer = (Footer);
;// CONCATENATED MODULE: ./components/User/_components/common/AddClientList/index.tsx











/***/ }),

/***/ 69135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_SortTypeDropdown; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs + 1 modules
var dist = __webpack_require__(46653);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ./constants/zIndex.ts
var zIndex = __webpack_require__(90122);
;// CONCATENATED MODULE: ./components/User/_components/common/SortTypeDropdown/index.styles.ts



var _templateObject;




var slideUp = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  from {\n    opacity: 0;\n    transform: translateY(2px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])));
var TriggerButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1o4cy7g2"
} : 0)("display:flex;min-width:150px;height:33px;flex-direction:row;align-items:flex-start;justify-content:space-between;padding:8px 8px 8px 16px;border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, ";border-radius:4px;gap:8px;" + ( true ? "" : 0));
var DropdownMenuContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Content */.VY,  true ? {
  target: "e1o4cy7g1"
} : 0)("position:relative;z-index:", zIndex/* Z_INDEX.dropdownMenuContents */.k.dropdownMenuContents, ";top:4px;display:flex;min-width:160px;flex-direction:column;align-items:flex-start;padding:8px;border:1px solid ", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.zinc_200;
}, ";background:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, ";border-radius:4px;box-shadow:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.elevation.xs;
}, ";gap:4px;&[data-side='bottom']{animation:", slideUp, " 0.15s ease-in-out;}" + ( true ? "" : 0));
var DropdownMenuRadioItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* RadioItem */.Rk,  true ? {
  target: "e1o4cy7g0"
} : 0)("min-width:160px;padding:8px;border-radius:4px;cursor:pointer;opacity:0.5;transition:all 0.15s ease-in-out;&[data-highlighted]{background:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.zinc_100;
}, ";opacity:1;outline:none;}&.active{opacity:1;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/common/SortTypeDropdown/index.tsx








var SortTypeDropdown = function SortTypeDropdown(_ref) {
  var _items$items$findInde, _items$items$findInde2;

  var items = _ref.items,
      onValueChanges = _ref.onValueChanges,
      initialValue = _ref.initialValue,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align,
      _ref$sideOffset = _ref.sideOffset,
      sideOffset = _ref$sideOffset === void 0 ? 0 : _ref$sideOffset,
      buttonCss = _ref.buttonCss;

  var _React$useState = react.useState((_items$items$findInde = (_items$items$findInde2 = items[items.findIndex(function (item) {
    return item.value === initialValue;
  })]) === null || _items$items$findInde2 === void 0 ? void 0 : _items$items$findInde2.label) !== null && _items$items$findInde !== void 0 ? _items$items$findInde : items[0].label),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var handleChangeValue = function handleChangeValue(value) {
    var index = items.findIndex(function (item) {
      return item.value === value;
    });
    setValue(items[index].label);
    onValueChanges(value);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Root */.fC, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Trigger */.xz, {
      asChild: true,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TriggerButton, {
        css: buttonCss,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "md-medium",
          color: "zinc_400",
          children: value
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:caret-down",
          size: 17,
          color: "zinc_400"
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Portal */.Uv, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownMenuContent, {
        align: align,
        sideOffset: sideOffset,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* RadioGroup */.Ee, {
          value: value,
          onValueChange: handleChangeValue,
          children: items.map(function (item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownMenuRadioItem, {
              value: item.value,
              className: item.label === value ? 'active' : '',
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "md-medium",
                color: "zinc_400",
                children: item.label
              })
            }, item.value);
          })
        })
      })
    })]
  });
};

/* harmony default export */ var common_SortTypeDropdown = (SortTypeDropdown);

/***/ }),

/***/ 73214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Tags_ComponentToolTip; }
});

// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-tooltip/dist/index.mjs
var dist = __webpack_require__(24990);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/pds-react/src/components/Text/index.tsx + 1 modules
var Text = __webpack_require__(26183);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/User/_components/common/Tags/ComponentToolTip/index.styles.ts

var ContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ephetup0"
} : 0)("padding:8px;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_500;
}, ";border-radius:4px;box-shadow:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.elevation.md;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/common/Tags/ComponentToolTip/index.tsx







var ComponentToolTip = function ComponentToolTip(_ref) {
  var children = _ref.children,
      description = _ref.description;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Provider */.zt, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Root */.fC, {
      delayDuration: 0,
      open: isOpen,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Trigger */.xz, {
        asChild: true,
        onClick: function onClick(e) {
          return e.preventDefault();
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          onMouseEnter: function onMouseEnter() {
            return setIsOpen(true);
          },
          onMouseLeave: function onMouseLeave() {
            return setIsOpen(false);
          },
          children: children
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Portal */.h_, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* TooltipContent */._v, {
          sideOffset: 10,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
              variant: "sm-medium",
              color: "white",
              textAlign: "center",
              children: description
            })
          })
        })
      })]
    })
  });
};

/* harmony default export */ var Tags_ComponentToolTip = (ComponentToolTip);

/***/ }),

/***/ 65118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ CLIENT_IDENTITY_REQUIRED_MESSAGE; },
/* harmony export */   "R": function() { return /* binding */ FORM_VALIDATIONS; }
/* harmony export */ });
var FORM_VALIDATIONS = {
  email: {
    pattern: {
      value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
      message: '잘못된 이메일 주소입니다.'
    },
    required: '이메일을 입력해주세요.'
  },
  hyperLink: {
    pattern: {
      value: /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\\+.~#?&\\/=]*)$/,
      message: '올바른 URL 형식이 아닙니다. http:// 또는 https:// 로 시작하는 링크를 입력하세요.'
    },
    required: '링크를 입력해주세요.'
  },
  memo: {
    maxLength: {
      value: 500,
      message: '메모는 500자 이내로 입력해주세요.'
    }
  }
};
/**
 * 고객 등록·수정의 신원 필수 조건 안내 문구.
 *
 * 서버 정책이 "고객명·연락처·회사명 중 하나" → "고객명·연락처·회사명·이메일 중 하나"로
 * 완화되면서, 같은 조건을 3개 화면이 제각각 표기하던 것을 한 곳으로 모은다.
 * 표기 순서는 폼의 필드 배치 순서를 따른다.
 */

var CLIENT_IDENTITY_REQUIRED_MESSAGE = '고객 이름, 회사명, 연락처, 이메일 중 하나는 필수입니다.';

/***/ }),

/***/ 9416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vt": function() { return /* binding */ CLIENT_LIST_QUERY_KEY; },
/* harmony export */   "ve": function() { return /* binding */ isLockedItem; }
/* harmony export */ });
/* unused harmony export getClientList */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7040);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74457);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




/**
 * prefix 매칭용 키. 정렬·검색·페이지가 달라도 모든 고객 목록 캐시를 한 번에 무효화한다.
 * 좋아요 토글·고객 등록처럼 목록을 바꾸는 동작에서 반드시 무효화해야 한다
 * (staleTime이 걸려 있어 마운트마다 다시 받아오지 않는다).
 */
var CLIENT_LIST_QUERY_KEY = ['getClientList'];
var isLockedItem = function isLockedItem(item) {
  return 'isLocked' in item;
};
var getClientList = function getClientList(_ref) {
  var sort = _ref.sort,
      search = _ref.search,
      page = _ref.page,
      limit = _ref.limit;
  // axios가 undefined 파라미터를 떨구므로 sort만 넘기는 호출부의 요청 URL은 그대로다.
  return _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .api.get */ .h.get("/client/list", {
    params: {
      sort: sort,
      search: search,
      page: page,
      limit: limit
    }
  });
};

var useClientList = function useClientList(request, options) {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)(['getClientList', request], function () {
    return getClientList(request);
  }, _objectSpread({
    /**
     * 목록 화면에서 페이지·검색어를 오갈 때마다 재요청하지 않도록 캐시를 유지한다.
     * 좋아요 토글과 고객 등록이 ['getClientList']를 무효화하므로 낡은 값이 남지 않는다.
     */
    staleTime: 30000
  }, options));
};

/* harmony default export */ __webpack_exports__["ZP"] = (useClientList);

/***/ })

}]);